import pure from "recompose/pure";

const style = { display: "flex" };

const CellEmptyClass = () => {
    return <div style={style} />;
};

export const CellEmpty = pure(CellEmptyClass);
